'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateGutter = exports.generateGrid = exports.GRID_SIZES = exports.GUTTERS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _hasOwnProperty = require('has-own-property');

var _hasOwnProperty2 = _interopRequireDefault(_hasOwnProperty);

var _breakpoints = require('../utils/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GUTTERS = exports.GUTTERS = [0, 8, 16, 24, 40];
var GRID_SIZES = exports.GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

var generateGrid = exports.generateGrid = function (globalStyles, theme, breakpoint) {
  var styles = _defineProperty({}, 'grid-' + breakpoint, {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });

  GRID_SIZES.forEach(function (size) {
    if (typeof size === 'boolean') {
      return;
    }

    var width = Math.round(size / 12 * 10e6) / 10e4 + '%';

    styles['grid-' + breakpoint + '-' + size] = {
      flexBasis: width,
      maxWidth: width
    };
  });

  if (breakpoint === 'xs') {
    Object.assign(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
};

var generateGutter = exports.generateGutter = function (theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      return;
    }

    styles['spacing-' + breakpoint + '-' + spacing] = {
      margin: -spacing / 2,
      width: 'calc(100% + ' + spacing + 'px)',
      '& > $typeItem': {
        padding: spacing / 2
      }
    };
  });

  return styles;
};

exports.default = function (theme) {
  var breakpoints = (0, _hasOwnProperty2.default)(theme, 'breakpoints') ? theme.breakpoints : (0, _breakpoints2.default)();

  return _extends({
    typeContainer: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    typeItem: {
      boxSizing: 'border-box',
      flex: '0 0 auto',
      margin: '0' },

    zeroMinWidth: {
      minWidth: 0
    },

    flex: {
      display: 'flex'
    },

    'direction-xs-column': {
      flexDirection: 'column'
    },

    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    'align-items-xs-center': {
      alignItems: 'center'
    },

    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    'align-content-xs-center': {
      alignContent: 'center'
    },

    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    'justify-xs-center': {
      justifyContent: 'center'
    },

    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }

  }, generateGutter(theme, 'xs'), breakpoints.keys.reduce(function (accumulator, key) {
    generateGrid(accumulator, _extends({}, theme, { breakpoints: breakpoints }), key);

    return accumulator;
  }, {}));
};